import React, { useEffect, useState, useContext } from 'react'
import jwtDecode from 'jwt-decode'
import { decryptString } from '../services/crypto'
import { saveHistoryAccess } from '../services/saveHistoryAccess'
import { CContainer, CHeader } from '@coreui/react'
import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './header/index'
import { api } from '../services/api'
import { AuthContext } from '../contexts/Auth'
import SessionLogout from '../views/components/notifications/modals/SessionLogout'
import ErrorModal from '../views/components/notifications/modals/ErrorModal'
import './AppHeader.css'

const AppHeader = () => {
  const { logoutSystem } = useContext(AuthContext)
  const [idPuxada] = useState(decryptString('idPuxada'))
  const [email] = useState(decryptString('email'))
  const [userName] = useState(decryptString('nome'))
  const [indUserLogged] = useState(decryptString('indUserLogged'))
  const [openDialogSession, setOpenDialogSession] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)

  const checkSession = async () => {
    if (!openDialogSession) {
      const loginState = await checkLogin()

      if (+indUserLogged !== loginState) setOpenDialogSession(true)
    }
  }

  const checkLogin = async () => {
    const abortController = new AbortController()
    const { signal } = abortController
    const token = localStorage.getItem('token')
    const headers = {
      Accept: 'application/json, text/plain, */*',
      Authorization: `Bearer ${token}`,
    }

    try {
      const response = await api.post(`/checklogin`, { email, consulta: 1 }, { headers, signal })
      return +response.data
    } catch (err) {
      console.log('ERROR(checkLogin): ', err)
      if (
        err.response &&
        err.response.data &&
        err.response.data.error !== undefined &&
        err.response.data.error === 'Invalid token!'
      ) {
        const infoToken = jwtDecode(token)
        saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
        logoutSystem('')
      } else {
        setOpenErrorModal(true)
      }

      return false
    } finally {
      abortController.abort()
    }
  }

  useEffect(() => {
    const intervalId = setInterval(checkSession, 10000)

    return () => clearInterval(intervalId)
    // eslint-disable-next-line
  }, [])

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <AppBreadcrumb />
        <div className="user-info-logged">
          <span>{`Olá ${userName}`}</span>
          <AppHeaderDropdown />
        </div>
      </CContainer>
      {openDialogSession && <SessionLogout openModal={true} />}
      {openErrorModal && (
        <ErrorModal
          openModal={true}
          setOpenErrorModal={setOpenErrorModal}
          message="Algo deu errado, tente mais tarde!"
          logout={idPuxada === undefined}
        />
      )}
    </CHeader>
  )
}

export default AppHeader
